import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a3f9116a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3f9116a')) {
      api.createRecord('a3f9116a', component.options)
    } else {
      api.reload('a3f9116a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a3f9116a&", function () {
      api.rerender('a3f9116a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/captain_bonuses/index.vue"
export default component.exports